








































import Vue, { VueConstructor } from 'vue'
import { notes, Note } from '../application/models/notes'
import { majorScale, naturalMinorScale, harmonicMinorScale, Scale } from '../application/models/scales'
import { SelectableT, selectRandom } from '../application/models/selectable'
import hasBreakpoints, { HasBreakpointsMixinComputed } from '@/mixins/hasBreakpoints'
import hasEnharmonics, { HasEnharmonicsMixinData } from '@/mixins/hasEnharmonics'

type Mixins = HasBreakpointsMixinComputed & HasEnharmonicsMixinData

export default (Vue as VueConstructor<Mixins>).extend({
  mixins: [hasBreakpoints, hasEnharmonics],
  data () {
    const selectableNotes = notes.map(n => new SelectableT(n, true))
    const selectableScales = [
      new SelectableT(majorScale, true),
      new SelectableT(naturalMinorScale, true),
      new SelectableT(harmonicMinorScale, true)
    ]
    return {
      note: selectableNotes[0],
      scale: selectableScales[0],
      selectableNotes,
      selectableScales
    }
  },
  beforeMount () {
    this.randomize()
  },
  computed: {
    availableNotes (): SelectableT<Note>[] {
      return this.selectableNotes.filter(n => n.selected)
    },
    availableScales (): SelectableT<Scale>[] {
      return this.selectableScales.filter(n => n.selected)
    },
    canRandomize (): boolean {
      return this.availableNotes.length > 0 && this.availableScales.length > 0
    }
  },
  methods: {
    randomize() {
      this.note = selectRandom(this.availableNotes)
      this.scale = selectRandom(this.availableScales)
    }
  }
})
